import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {membership} = contexts;

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: AlarmIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:offered_program_created_client.title', {
      coachName: membership?.coaches![0]!.name,
    }),
  };
};
